/**
 * Carrier/IATA code to airline display name.
 * Mirrors prmassist-backend/prm-cpu/utils/airline-names.js; keep the two in sync.
 */
export const carrierCodeToName = {
  EI: 'Aer Lingus',
  FR: 'Ryanair',
  BA: 'British Airways',
  AA: 'American Airlines',
  UA: 'United Airlines',
  LH: 'Lufthansa',
  AF: 'Air France',
  KL: 'KLM',
  EK: 'Emirates',
  QR: 'Qatar Airways',
  TK: 'Turkish Airlines',
  DL: 'Delta Airlines',
  AC: 'Air Canada',
  LX: 'SWISS',
  VY: 'Vueling',
  IB: 'Iberia',
  MS: 'Egyptair',
  AY: 'Finnair',
  BY: 'TUI',
  TOM: 'TUI Airways',
  TUI: 'TUI fly',
  SK: 'SAS Scandinavian Airlines',
  CX: 'Cathay Pacific',
  NH: 'All Nippon Airways (ANA)',
  JL: 'Japan Airlines',
  SQ: 'Singapore Airlines',
  OZ: 'Asiana Airlines',
  QF: 'Qantas Airways',
  AZ: 'Alitalia',
  SU: 'Aeroflot',
  KE: 'Korean Air',
  VS: 'Virgin Atlantic',
  VA: 'Virgin Australia',
  NZ: 'Air New Zealand',
  CZ: 'China Southern Airlines',
  MU: 'China Eastern Airlines',
  ET: 'Ethiopian Airlines',
  TP: 'TAP Air Portugal',
  A3: 'Aegean Airlines',
  SI: 'Blue Islands',
  EY: 'Etihad Airways',
  WS: 'WestJet',
  BT: 'Air Baltic',
  OU: 'Croatia Airlines',
  XQ: 'SunExpress',
  LS: 'Jet2.com',
  EZY: 'EasyJet',
  U2: 'EasyJet',
  UL: 'SriLankan Airlines',
  H4: 'HiSky',
  RK: 'Ryanair UK',
  RR: 'Buzz',
  DY: 'Norwegian Air Shuttle',
  AP: 'AlbaStar',
  TS: 'Air Transat',
  '2S': 'Pegas Fly',
  '3L': 'Intersky',
  '5K': 'Hi Fly',
  '8H': 'Heli Air Monaco',
  CL: 'Lufthansa CityLine',
  E4: 'Enter Air',
  EA: 'European Air Charter',
  FI: 'Icelandair',
  LM: 'Loganair',
  OG: 'Flynas',
  OR: 'TUI fly Netherlands',
  R6: 'RACSA',
  SR: 'Sundair',
  T3: 'Eastern Airways',
  TB: 'TUI fly Belgium',
  V3: 'Carpatair',
  W4: 'LC Perú',
  W6: 'Wizz Air',
  WG: 'Sunwing Airlines',
  XC: 'Corendon Airlines',
  YW: 'Air Nostrum',
  '5M': 'Sibaviatrans',
  '6Y': 'SmartLynx Airlines',
  A5: 'HOP!',
  D0: 'DHL Air UK',
  E6: 'Bringer Air Cargo',
  E9: 'Evelop Airlines',
  EE: 'Regional Jet',
  EW: 'Eurowings',
  FH: 'Freebird Airlines',
  FX: 'FedEx Express',
  HU: 'Hainan Airlines',
  HV: 'Transavia',
  I2: 'Iberia Express',
  J0: 'Jet4you',
  LW: 'Pacific Wings',
  NO: 'Neos',
  RC: 'Atlantic Airways',
  SN: 'Brussels Airlines',
  WK: 'Edelweiss Air',
  WX: 'CityJet',
  ZQ: 'Locair',
  SV: 'Saudia',
  '6B': 'TUIfly Nordic',
  B6: 'JetBlue Airways',
};

/** Airline name from a flight number (e.g. "U2631" → "EasyJet"), falling back to the carrier code. */
export const getAirlineNameFromFlightNumber = (flightNumber, carrierCode) => {
  const candidates = [carrierCode, String(flightNumber || '').slice(0, 3), String(flightNumber || '').slice(0, 2)]
    .filter(Boolean)
    .map((c) => String(c).toUpperCase());
  for (const code of candidates) {
    if (carrierCodeToName[code]) return carrierCodeToName[code];
  }
  return (carrierCode || String(flightNumber || '').slice(0, 2)).toUpperCase() || 'N/A';
};
